import { render } from "./RecipeCardPopular.vue?vue&type=template&id=5cdd2050&scoped=true"
import script from "./RecipeCardPopular.vue?vue&type=script&lang=js"
export * from "./RecipeCardPopular.vue?vue&type=script&lang=js"

import "./RecipeCardPopular.vue?vue&type=style&index=0&id=5cdd2050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdd2050"]])

export default __exports__